//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import starValue from './starValue.vue'
import native from '../../lib/native'
export default {
  props: {
    data: {
      type: Object
    },
    isBottom: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      doctorServiceList:[]
    }
  },
  created(){
    if(this.data.doctorServiceList){
      let tempArr = []
      this.data.doctorServiceList.forEach( function (item, index, arr) {
        if(item.menuname=='门诊预约'){
          item.isuse = 'N'
        }
        let obj = {}
        obj.text = item.menuname
        obj.isuse=item.isuse
        tempArr.push(obj)
      })
      this.doctorServiceList = tempArr.filter(item=>item.isuse == 'Y').concat(tempArr.filter(item=>item.isuse == 'N'))
      // this.doctorServiceList = this.data.doctorServiceList.filter(item=>item.isuse == 'Y').concat(this.data.doctorServiceList.filter(item=>item.isuse == 'N'))
    }
  },
  computed: {
    goodAtValue: function () {
      let str = '',
          len = this.data.goodAt.lenght
      this.data.goodAt.forEach(function (item, index, arr) {
        if (index < len) {
          str += i + '<span class="separate"></span>'
        } else {
          str += i
        }
      })
      return str
    },
    effectData: function () {
      return { value: this.data.effect / 100 }
    },
    attitudeData: function () {
      return { value: this.data.attitude / 100 }
    }
  },
  methods:{
    goDoctorsDetail(id){
      this.$emit('goDetail',id)
    },
  },
  components: {
    starValue
  }
}



// WEBPACK FOOTER //
// ./src/components/clinic/doctorItem.vue